import {
  SiApplemusic, SiYoutubemusic, SiSpotify, SiTidal, SiMixcloud, SiTiktok,
  SiDeezer, SiSoundcloud, SiInstagram, SiBeatport, SiAudiomack, SiNapster, SiYoutube,
} from "react-icons/si";
import { ShoppingBag, Music2 } from "lucide-react";

export const SMARTLINK_PLATFORMS = [
  { key: "apple_music", name: "Apple Music", icon: SiApplemusic, color: "#FA243C", verb: "add" },
  { key: "youtube_music", name: "YouTube Music", icon: SiYoutubemusic, color: "#FF0000", verb: "add" },
  { key: "spotify", name: "Spotify", icon: SiSpotify, color: "#1ED760", verb: "save" },
  { key: "tidal", name: "TIDAL", icon: SiTidal, color: "#000000", verb: "save" },
  { key: "mixcloud", name: "Mixcloud", icon: SiMixcloud, color: "#5000FF", verb: "save" },
  { key: "tiktok", name: "TikTok", icon: SiTiktok, color: "#000000", verb: "save" },
  { key: "amazon_music", name: "Amazon Music", icon: ShoppingBag, color: "#FF9900", verb: "save" },
  { key: "deezer", name: "Deezer", icon: SiDeezer, color: "#A238FF", verb: "save" },
  { key: "soundcloud", name: "SoundCloud", icon: SiSoundcloud, color: "#FF5500", verb: "save" },
  { key: "instagram", name: "Instagram", icon: SiInstagram, color: "#E4405F", verb: "save" },
  { key: "beatport", name: "Beatport", icon: SiBeatport, color: "#1BA65B", verb: "save" },
  { key: "audiomack", name: "Audiomack", icon: SiAudiomack, color: "#FFA200", verb: "save" },
  { key: "napster", name: "Napster", icon: SiNapster, color: "#FF0050", verb: "save" },
  { key: "anghami", name: "Anghami", icon: Music2, color: "#6C2EB9", verb: "save" },
];

export const SMARTLINK_SOCIALS = [
  { key: "instagram", name: "Instagram", icon: SiInstagram, color: "#E4405F" },
  { key: "tiktok", name: "TikTok", icon: SiTiktok, color: "#000000" },
  { key: "youtube", name: "YouTube", icon: SiYoutube, color: "#FF0000" },
];
